const STANDINGS_URL = "https://s3.us-east-1.amazonaws.com/vibesleague.fun/standings.json";
const STATS_URL = "https://s3.us-east-1.amazonaws.com/vibesleague.fun/cumulative_stats.json";


export { STANDINGS_URL, STATS_URL };
